<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic 
ib-row
    ib-col(class="scroll", class="flex  after-8", style="max-height:75vh;")
        ib-table-basic(
            :data="progressBarData",
            row,
            colborder
            class="fs7 fg70 shrink",
            spacing="huge",
            style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;"
            v-if="apiStatus === 'wait'"
        )
            ib-table-col(width="100%", class="header")
            template(slot="body", slot-scope="res")
                td
                    ib-progress-circular(width="128px", height="128px", class="alignment")
        ib-table-basic(
            :data="searchResults",
            row,
            colborder
            class="fs7 fg70 shrink",
            spacing="huge",
            style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;"
            v-if="apiStatus === 'results'"
        )
            ib-table-col(width="9ch", sticky, class="header")
                div(class="border-bottom", @click.stop="sortResults('symbol', '')")
                    span(:title="$t('symbol')") {{ $t('symbol') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'symbol' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('symbol', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'symbol' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('symbol', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="18ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('description', '')")
                    span(:title="$t('description')") {{ $t('description') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'description' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('description', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'description' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('description', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="10ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('local_symbol', '')")
                    span(:title="$t('ibkr_symbol')") {{ $t('ibkr_symbol') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'ibkr_symbol' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('local_symbol', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'ibkr_symbol' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('local_symbol', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="9ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('currency', '')")
                    span(:title="$t('currency')") {{ $t('currency') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'currency' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('currency', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'currency' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('currency', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="8ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('type', '')")
                    span(:title="$t('product')") {{ $t('product') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'product' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('type', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'product' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('type', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="8ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('country', '')")
                    span(:title="$t('region')") {{ $t('region') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'region' && previousSort.dir === 'asc' }",
                        @click.stop="sortResults('country', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'region' && previousSort.dir === 'desc' }",
                        @click.stop="sortResults('country', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(v-if="newProducts === 'T' && status === 'filterResults'", width="10ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('new', '')")
                    span(:title="$t('new_product')") {{ $t('new_product') }}
                    span(
                        class="up", 
                        :class="{'active-sort': previousSort.type === 'new_product' && previousSort.dir === 'asc' }", 
                        @click.stop="sortResults('new', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'new_product' && previousSort.dir === 'desc' }", 
                        @click.stop="sortResults('new', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="16ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('exchange_id', '')")
                    span(:title="$t('exchange')") {{ $t('exchange') }}
                    span(
                        class="up", 
                        :class="{'active-sort': previousSort.type === 'exchange' && previousSort.dir === 'asc' }", 
                        @click.stop="sortResults('exchange_id', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'exchange' && previousSort.dir === 'desc' }", 
                        @click.stop="sortResults('exchange_id', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
                    span(v-if="isPrimaryExchange") *Primary Exchange
            template(slot="body", slot-scope="res")
                td(
                    v-if="res['type'] === 'BOND'",
                    class="text-center",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                ) -
                td(
                    v-else-if="res['type'] != 'BOND' && res['type'] != 'FUND'",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                    :title="res['symbol']"
                ) {{ res['symbol'] }}
                td(
                    v-if="(res['type'] === 'FUND')",
                    :class="{ align: checkCusip(res['symbol']) === '-' }",
                    v-text="checkCusip(res['symbol'])",
                    :title="checkCusip(res['symbol'])"
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                )
                td(
                    v-if="res['description'] != null",
                    :title="convertAmpersand(res['description'], res['type'], res['conid'])",
                    :class="{ description: activateLink(res) }",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                    v-text="convertAmpersand(res['description'], res['type'], res['conid'])"
                )
                    //- span(class="external-icon")
                        +icon-basic-external
                td(
                    v-if="res['description'] === null",
                    :class="{ description: activateLink(res) }",
                    :title="res['symbol']",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                ) {{ res['symbol'] }}
                    //- span(class="external-icon",)
                        +icon-basic-external 
                td(
                    v-if="res['type'] === 'BOND'", 
                    class="text-center",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                ) -
                td(
                    v-else-if="(res['type'] === 'FUND')",
                    :class="{ align: checkCusip(res['localSymbol']) === '-' }",
                    v-text="checkCusip(res['localSymbol'])",
                    :title="checkCusip(res['localSymbol'])",
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                )
                td(
                    v-else-if="(res['type'] != 'FUND') || (res['type'] != 'BOND')",
                    :title="res['localSymbol']",
                )
                    span(v-if="res['localSymbol'].split(',').length < 3 && !showLocalSymbol[res['localSymbol']]", :title="res['localSymbol'].split(',').slice(0,2).join()") {{ res['localSymbol'].split(',').slice(0,2).join() }}
                    span(v-if="res['localSymbol'].split(',').length > 2 && !showLocalSymbol[res['localSymbol']]", , :title="res['localSymbol'].split(',').slice(0,2).join()") {{ res['localSymbol'].split(',').slice(0,2).join() }}
                    span(v-if="showLocalSymbol[res['localSymbol']] ", :title="res['localSymbol']") {{ res['localSymbol'] }}
                    button(class="btn-no-style", v-if="res['localSymbol'].split(',').length > 2 && !showLocalSymbol[res['localSymbol']] ", @click="toggleLocalSymbolDetails(res)") , +{{ res['localSymbol'].split(',').slice(2).length }}
                    button(class="btn-no-style", v-if="showLocalSymbol[res['localSymbol']] && res['localSymbol'].split(',').length > 2", @click="toggleLocalSymbolDetails(res)") , Show Fewer

                td(@click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['currency'] === null && res['localSymbol'].includes('.')", v-text="res['localSymbol'].split('.')[1]", :title="res['localSymbol'].split('.')[1]")
                td(@click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-else-if="res['currency'] === null && res['type'] === 'CMDTY'", v-text="res['symbol'].substring(3)", :title="res['symbol'].substring(3)")
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-else-if="res['currency'] === null", v-text="'N/A'", title="N/A")
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-else-if="res['currency']", v-text="res['currency']", :title="res['currency']")
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'STK'", title="Stocks") Stocks
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'BOND'", title="Bonds") Bonds
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'CMDTY'", title="Metal") Metal
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'CFD'", title="CFD") CFD
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'OPT'", title="Options") Options  
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'FUND'", title="Mutual Funds") Mutual Funds
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'WAR'", title="Warrants") Warrants
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'FUT'", title="Futures") Futures
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'ETF'", title="ETF") ETF
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'IOPT'", title="Structured Products") Structured Products
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'FOP'", title="Options on Futures") Options on Futures
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'CRYPTO'", title="Crypto") Crypto
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'IND'", title="Indices") Indices
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['type'] === 'CASH'", title="Currencies") Currencies
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['country'] === null", class="start-64") -
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])", 
                    v-if="res['country']", :title="res['country']") {{ res['country'] }}
                td(
                    @click="createlink(res['symbol'], res['conid'], res['underConid'], res['type'], res['currency'], res['country'], res['assocEntityId'], res['description'])",
                    v-if="newProducts === 'T' && status === 'filterResults'", title="Yes") Yes
                td()
                    span(v-if="res['exchangeId'].split(',').length < 3 && !showExchange[res['conid']]", :title="res['exchangeId'].split(',').slice(0,2).join()") {{ res['exchangeId'].split(',').slice(0,2).join() }}
                    span(v-if="res['exchangeId'].split(',').length > 2 && !showExchange[res['conid']] && res['conid'] != null", , :title="res['exchangeId'].split(',').slice(0,2).join()") {{ res['exchangeId'].split(',').slice(0,2).join() }} 
                    span(v-if="res['exchangeId'].split(',').length > 2 && !showExchange[res['underConid']] && res['conid'] === null", , :title="res['exchangeId'].split(',').slice(0,2).join()") {{ res['exchangeId'].split(',').slice(0,2).join() }}
                    span(v-if="showExchange[res['conid']]", :title="res['exchangeId']") {{ res['exchangeId'] }}
                    span(v-else-if="showExchange[res['underConid']]", :title="res['exchangeId']") {{ res['exchangeId'] }}
                    button(class="btn-no-style", v-if="res['exchangeId'].split(',').length > 2 && !showExchange[res['conid']] && res['conid'] != null", @click="toggleDetails(res)") , +{{ res['exchangeId'].split(',').slice(2).length }}
                    button(class="btn-no-style", v-if="res['exchangeId'].split(',').length > 2 && !showExchange[res['underConid']] && res['conid'] === null", @click="toggleDetails(res)") , +{{ res['exchangeId'].split(',').slice(2).length }}
                    button(class="btn-no-style", v-if="res['conid'] != null && showExchange[res['conid']] && res['exchangeId'].split(',').length > 2", @click="toggleDetails(res)") , Show Fewer
                    button(class="btn-no-style", v-if="res['exchangeId'].split(',').length > 2 && showExchange[res['underConid']] && res['conid'] === null", @click="toggleDetails(res)") , Show Fewer

        div(v-if="products.length > 0", class="pagination")
            div
                ib-dropdown(
                    :data="dropdownData",
                    v-model="numShow",
                    :placeholder="$t('show_rows')",
                    align="center",
                    class="dropdown-style",
                )
            div(class="pagination-style")
                span {{ $t('page') }}
                ib-field(
                    :disabled="totalPage <= 1",
                    width="7ch",
                    align="center",
                    placeholder=1,
                    class="outsetx-8",
                    v-model="pageNumber",
                    @change="changePage"
                )
                span {{ $t('of  ') }}
                    strong(style="margin-left:4px;") {{ totalPage }}
                div(class="page-btn")
                    ib-button(:disabled="pageNumber <= 1", @click="changePage(--pageNumber)")
                        +icon-arrow-back
                    ib-button(:disabled="pageNumber >= totalPage", @click="changePage(++pageNumber)")
                        +icon-arrow-forward
    SearchProducts(ref='searchProducts')
    InterimPage(ref='interimPage')
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import api from '../api/index.js';
import SearchProducts from './SearchProducts.vue';
import InterimPage from './InterimPage.vue';

export default {
    Name: 'ProductSearchResults',
    components: {
        SearchProducts,
        InterimPage,
    },
    data() {
        return {
            productList: [],
            typeList: '',
            results: '',
            direction: false,
            warrantsCookie: document.cookie.split('IB_QD_WAR=').pop().split(';').shift(),
            progressBarData: ["in progress"],
            makeSecdefCall: false,
            showExchange: {},
            showLocalSymbol: {},
        }
    },
    created() {
        this.searchResults.map(res => {
            if(res.type === 'BOND'){
                this.makeSecdefCall = true;
            }
        });
        if(this.makeSecdefCall === true){
            this.productDetails();
        }
    },
    watch: {
        numShow(newValue, oldValue){
            Vue.nextTick(() => {
                console.debug(this.selectedProductType);
                if(this.status === "filterResults"){
                    this.getComp(true);
                } else if(this.status === 'prodResults'){
                    if(this.selectedProductType === 'all'){
                        this.showAllProducts();
                    } else {
                        this.getComp(true);
                    }
                }
            });
        },
    },
    methods: {
        getComp(paging) {
            // splits the numShow string into substring and returns the number in the string
            let limit = this.numShow.split(' ')[1];
            if (!limit) limit = 100;
            if (!paging) this.pageNumber = 1;
            const options = {
                pageSize: limit,
                pageNumber: this.pageNumber,
                sortField: this.currentSort.type,
                sortDirection: this.currentSort.dir,
                domain: this.selectedDomain,
            };
            
            if(this.selectedExch.length === 0){
                this.search();
            } else {
                this.setSearchResults([]);
                let type = [];
                type.push(this.selectedProductType);
                this.typesList.map(val => {
                    if(val.productType === this.selectedProductType){
                        this.setTotalPages(val.totalCount);
                    }
                })
                this.setApiStatus('wait');
                api.getProductsByExchangeAndType(this.selectedExch, type, options)
                    .then((response) => {
                        if(response.products.length === 0){
                            $alert('No results found');
                            this.setStatus('exchangeResults');
                        } else {
                            console.debug("response", response.products.length);
                            const filteredResponse = response.products.filter(res => res.type === this.selectedProductType).map(res => res);
                            this.setProductResults(filteredResponse);
                            this.setSearchResults(filteredResponse);
                            this.searchResults.map(res => {
                                if(res.type === 'BOND'){
                                    this.makeSecdefCall = true;
                                }
                            });
                            if(this.makeSecdefCall === true){
                                this.productDetails();
                                const warning = this.searchResults.find(product => product.type === 'OPT' || product.type === 'FUT' || product.type === 'FOP');
                                if(warning) {
                                    this.setShowWarning(true);
                                } else {
                                    this.setShowWarning(false);
                                }
                            }
                            this.setApiStatus('results');

                            this.setPreviousSort(this.currentSort);
                        }     
                    })
                    .catch(error => {
                        console.error(error);
                    })
            }
        },
        changePage(value) {
            this.setSecDefData("");
            if (isNaN(value)) return;
            this.pageNumber = value;
            this.getComp(true);
        },
        createlink(symbol, conid, underConid, type, currency, country, assocEntityId, description) {
            if(type === 'STK' || type === 'ETF' || type === 'BOND' || type === 'FUND' || type === 'CASH' || type === 'CMDTY' || type === 'CRYPTO'  || type === 'CFD' || type === 'FUT' || type === 'FOP' || type === 'OPT' || type === 'WAR'){
                return this.viewContractDetails(symbol, description, conid, underConid, type, currency);
            }
        },
        productOverview(assocEntityId, isEntityId, type){
            if(isEntityId && type === 'OPT') {
                window.open("https://contract.ibkr.info/index.php?action=Option+Chain&entityId=" + assocEntityId,"_blank", "width=800px, height=500px");
            } else if(isEntityId && type === 'FUT'){
                window.open("https://contract.ibkr.info/index.php?action=Futures+Search&entityId=" + assocEntityId,"_blank", "width=800px, height=500px");
            }
        },
        activateLink(res) {
            if(res['type'] === 'STK' || res['type'] === 'ETF' || res['type'] === 'BOND' || res['type'] === 'FUND' || res['type'] === 'CASH' || res['type'] === 'CMDTY' 
                || res['type'] === 'CRYPTO' || res['type'] === 'CFD' || res['type'] === 'FUT' || res['type'] === 'FOP' || res['type'] === 'OPT' || res['type'] === 'WAR'){
                return true;
            }
            return false;
        },
        viewContractDetails(symbol, description, conid, underConid, type, currency) {
            if(type === 'FUT' || type === 'FOP' || type === 'CFD' || type === 'WAR'){
                this.$refs.interimPage.open(symbol, description, conid, underConid, type, currency);
            } else {
                this.$refs.searchProducts.open(description, conid, underConid, type);
            }
            return false;
        },
        changePage(value) {
            this.setSecDefData("");
            if (isNaN(value)) return;
            this.pageNumber = value;
            if(this.status === "filterResults" || this.selectedProductType != 'all'){
                this.getComp(true);    
            } else {
                this.showAllProducts();
            }
        },
        sortResults(type, dir) {
            let sortOptions = {};
            console.debug("previous sort", this.previousSort.type, this.previousSort.dir);
            if(dir.length === 0){
                if(this.previousSort.dir === 'desc'){
                    sortOptions.dir = 'asc';
                } else {
                    sortOptions.dir = 'desc';
                }
                sortOptions.type = type;
            } else {
                sortOptions.type = type;
                sortOptions.dir = dir;
            }
            this.setCurrentSort(sortOptions);
            console.debug("current sort", this.currentSort.type, this.currentSort.dir);
            // Don't sort column again if already sorted.
            if (this.previousSort.type && (this.previousSort.type === this.currentSort.type && this.previousSort.dir === this.currentSort.dir)) {
                return;
            }

            if(this.status === "filterResults"){
                this.getComp(true);
            } else if(this.status === 'prodResults'){
                if(this.selectedProductType === 'all'){
                    this.showAllProducts();
                } else {
                    this.getComp(true);
                }
            }
        },
        convertAmpersand(description, type, conid) {
            let assetDescription = '';
            if(type != "BOND"){
                assetDescription = description.replace(/&amp;/g, "&");
                assetDescription = assetDescription.replace(/&#178;/g, "²");
                assetDescription = assetDescription.replace(/&#201;/g, "É");
                if (assetDescription.charAt(assetDescription.length - 1) === '-') {
                    assetDescription = assetDescription.slice(0, -1);
                }
                return assetDescription;
            } else {
                if(this.secDefData.length != 0) {
                    for (let i = 0; i < this.secDefData.length; i++) {
                        const item = this.secDefData[i];
                        if (item.conid === conid) {
                            assetDescription = item.fullName;
                            break;
                        }
                    }
                }
                return assetDescription;
            }
        },
        productDetails(){
            const conids = this.searchResults.map(res => res.conid);

            // Splitting conids into two arrays.
            const conidArray = [];
            conidArray.push(conids.slice(0,conids.length/2));
            conidArray.push(conids.slice(conids.length/2));
            this.setSecDefData("");
            conidArray.forEach(arr => {
                api.getSecdefData(arr)
                    .then(response => {
                        response.secdef.forEach(res => {
                            this.setSecDefData(res);
                        })
                    })
            })
        },
        checkCusip(symbol) {
            let isCusip = /^[0-9]{3}[a-zA-Z0-9]{2}[a-zA-Z0-9*@#]{3}[0-9]$/g.test(symbol) ? true : false;
            if(isCusip === true || symbol.length > 5) {
                return "-";
            } else {
                return symbol;
            }
        },
        showAllProducts() {
            let limit = this.numShow.split(' ')[1];
            if (!limit) limit = 100;
            const options = {
                pageNumber: this.pageNumber,
                pageSize: limit,
                sortField: this.currentSort.type,
                sortDirection: this.currentSort.dir,
                domain: this.selectedDomain,
            }
            
            if(this.searchTerm && this.useSearchTerm){
                options.productSymbol = this.searchTerm.toUpperCase();
            }
            this.setApiStatus('wait');
            api.getProductsByExchange(this.selectedExch, options)
                .then(response => {
                    if(response.products.length === 0){
                        $alert('No results found');
                        this.setStatus('exchangeResults');
                    } else {
                        this.setProducts(response.products);
                        
                        // Populating the results table with pre selected product type
                        const filteredResponse = response.products;
                        
                        // Filter results based on restriction for various products types
                        let restrictedProducts = this.restrictedProducts.map(product => product.symbol);
                        let results = [];
                        for(let i=0; i<this.products.length; i++){
                            if(this.selectedDomain === 'jp'){
                                if(!restrictedProducts.includes(this.products[i].symbol)){
                                    results.push(this.products[i]);
                                } else {
                                    console.debug("restricted product: ", this.products[i].symbol);
                                }
                            } else if(this.products[i].type === 'CRYPTO') {
                                if(this.allowedCryptoProducts.includes(this.products[i].symbol)){
                                    results.push(this.products[i]);
                                }
                            } else {
                                results.push(this.products[i]);
                            }
                        }
                        this.setProductResults(filteredResponse);
                        this.setSearchResults(filteredResponse);
                        // Funcitonality to show/hide 250, 500 options in Show Rows dropdown
                        if(this.searchResults.length < 100){
                            this.setResultStatus(false);
                        } else {
                            this.setResultStatus(true);
                        }
                        // Updated status flag to display results
                        this.setApiStatus('results');
                        
                    }
                })
                .catch(error => console.error(error))
        },
        toggleLocalSymbolDetails(product){
            this.$set(this.showLocalSymbol, product.localSymbol, !this.showLocalSymbol[product.localSymbol])
        },
        toggleDetails(product) {
            if(product.conid != null){
                this.$set(this.showExchange, product.conid, !this.showExchange[product.conid]);
            } else {
                this.$set(this.showExchange, product.underConid, !this.showExchange[product.underConid]);
            }
        },
        ...mapActions(['setDefaultOption', 'setSelectedProductType', 'setProductResults', 'setProducts', 'setTypesList', 'search', 'reset', 'setSearchResults', 'setPageNumber', 'setNumShow', 
        'setSecDefData', 'setApiStatus', 'setStatus', 'setTotalPages', 'setResultStatus', 'setCurrentSort', 'setPreviousSort', 'setProducts', 'setShowWarning'])
    },
    mounted() {
        // Logic for mutual funds disclosures
        const mfund = this.searchResults.find(result => result.type === 'FUND');
        const etf = this.searchResults.find(result => result.type === 'ETF');
        const crypto = this.searchResults.find(result => result.type === 'CRYPTO');
        const asxExchange = this.searchResults.find(result => result.country === 'AU');
        const isUS = this.searchResults.find(result => result.country === 'US');
        const notes = document.querySelector('.notes');
        const etfDisclosure = document.querySelector('.etf-disclosure');
        const cryptocurrencyUsDisclosure = document.querySelector('.cryptocurrency-disclosure');
        const mfundDisclosure = document.querySelector('.mutual-fund-disclosure');
        const exchangeSpecificDisclosure = document.querySelector('.exchange-specific-disclosure');
        const usDisclosure = document.querySelector('.us-disclosure');
        const nonUsDisclosure = document.querySelector('.non-us-disclosure');
        const usDisclosureNotes = document.querySelectorAll('.us-disclosure-notes');
        const nonUsDisclosureNotes = document.querySelectorAll('.non-us-disclosure-notes');

        /* This disclosure was requested by George Chen through email. "disclsore-text" class appends "/terriroties or for all clients" 
        to exiting mutual fund disclosure */
        const disclosureText = document.querySelector('.disclosure-text');

        if(etf && this.selectedDomain === 'com') {
            if(notes){
                notes.style.display = "block";
            }
            etfDisclosure.style.display = "block";
        }
        if(crypto && this.selectedDomain === 'com') {
            if(notes){
                notes.style.display = "block";
            }
            cryptocurrencyUsDisclosure.style.display = "block";
        }
        if(this.selectedDomain === 'sg' || this.selectedDomain === 'hk'){
            disclosureText.style.display = "inline";
        }
        if(mfund) {
            if(notes){
                notes.style.display = "block";
            }
            mfundDisclosure.style.display = "block";
            
            if(!isUS){
                if(nonUsDisclosure){
                    nonUsDisclosure.style.display = "inline";
                }
                for(let i = 0; i < nonUsDisclosureNotes.length; i++){
                    nonUsDisclosureNotes[i].style.display = "list-item";
                }
            } else {
                if(usDisclosure){
                    usDisclosure.style.display = "block";
                }
                for(let i = 0; i < usDisclosureNotes.length; i++){
                    usDisclosureNotes[i].style.display = "list-item";
                }
            }
        } else if(asxExchange && this.status === 'prodResults'){
            if(notes){
                notes.style.display = "block";
            }
            exchangeSpecificDisclosure.style.display = "block";
        } else if(mfund && (asxExchange && this.status === 'prodResults')){
            if(notes){
                notes.style.display = "block";
            }
            mfundDisclosure.style.display = "block";
            exchangeSpecificDisclosure.style.display = "block";
        }
    },
    computed: {
        pageNumber: {
            get: function() {
                return this.$store.state.pageNumber;
            },
            set: function(newValue) {
                this.setPageNumber(newValue);
            }
        },
        numShow: {
            get: function() {
                return this.$store.state.numShow;
            },
            set: function(newValue) {
                this.setNumShow(newValue);
            }
        },
        totalPage: function() {
            let pages = (this.totalPages / this.numShow.split(' ')[1]);
            if(Number.isInteger(pages)){
                return parseInt(pages);
            } else {
                return parseInt(pages + 1);
            }
        },
        dropdownData: function() {
            if(this.resultStatus === false){
                return ['100'].map(text => this.$t('show') + " "+ text + " " + this.$t('rows'));    
            } else {
                return ['100','250', '500'].map(text => this.$t('show') + " "+ text + " " + this.$t('rows'));
            } 
        },
        isPrimaryExchange: function() {
            let types = [];
            this.searchResults.map(res => {
                if(!types.includes(res.type)){
                    types.push(res.type);
                };
            });

            if(types.includes('STK') || types.includes('ETF')){
                return true;
            } else {
                return false;
            }
        },
        ...mapGetters(['selectedDomain']),
        ...mapState(['productResults','selectedProductType','products','typesList', 'selectedExch', 'totalPages',
         'orderTypesResults', 'uniqueNatives', 'uniqueSimulated', 'status', 'searchResults', 'newProducts', 'resultStatus', 'searchProductType',
         'selectedProduct', 'secDefData', 'selectedExch', 'apiStatus', 'allowedCryptoProducts', 'restrictedProducts', 'productTypes', 'status', 
         'currentSort', 'previousSort', 'searchTerm', 'useSearchTerm'])
    },
}
</script>
 
<style lang="less" scoped>
.header {
    background-color: white;
}
.results {
    padding: 20px;
}
span {
    .up {
        position: relative;
        right: -2px;
        top: -5px;
        &.active-sort {
            color: #000;
        }
    }
    .down {
        position: relative;
        left: -12px;
        top: 3px;
        &.active-sort {
            color: #000;
        }
    }
}
.description {
    color: red;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 10px;
}
td {
    text-wrap: wrap;
    word-wrap: break-word;
}
.external-icon {
    svg {
        position: relative;
        top: 0.8px;
        left: 6px;
        width: 1em;
        height: 1em;
    }
}
.align {
    text-align: center;
}

@media(max-width:567px){
    .pagination {
        display: block;
        justify-content: space-between;
        align-items: center;
    }

    .pagination-style {
        display: flex;
        align-items: center;
    }

    .dropdown-style {
        font-family: "Proxima Nova", Verdana, Arial, sans-serif;
        width: 100%;
    }

    .page-btn {
        margin-left: auto;
    }
}

@media(min-width:567px){
    .pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .pagination-style {
        display: flex;
        align-items: center;
    }

    .dropdown-style {
        font-family: "Proxima Nova", Verdana, Arial, sans-serif;
    }
}
.alignment {
    position: relative;
    left: 45%;
}
.btn-no-style{
    color: blue;
    border: none;
    background: none;
    cursor: pointer;
}
</style>


